import styled from 'styled-components';

const StakeConfigurePlanWrapper = styled.div`
    .title {
        font-size: 18px;
    }
    .ant-radio-group {
        display: flex;
        flex-direction: column;
        margin: 1rem 1rem 3rem 1rem;
        .ant-radio-wrapper {
            margin: 10px 0;
            color: #000000;
        }
    }
    .btn-wrapper {
        .ant-btn {
            width: 100%;
        }
    }
`
export default StakeConfigurePlanWrapper